import { makeAutoObservable, observable, action } from 'mobx'

export class WalletConnectionStore {
  constructor() {
    makeAutoObservable(this, {
      isModalOpened: observable,
      wcPairingUri: observable,
      connectionRejected: observable,
      errorCallback: observable,
      setModalOpen: action,
      setWcPairingUri: action,
      setConnectionRejected: action,
      handleConnectionRejected: action,
    })
  }

  @observable
  isModalOpened = false

  /** WalletConnect pairing URI for in-app QR (wagmi + display_uri). */
  @observable
  wcPairingUri: string | undefined = undefined

  @observable
  connectionRejected = false

  @observable
  errorCallback?: () => void = undefined

  @action
  setModalOpen(open: boolean) {
    this.isModalOpened = open
  }

  @action
  setWcPairingUri(uri: string | undefined) {
    this.wcPairingUri = uri
  }

  @action
  setConnectionRejected(rejected: boolean) {
    this.connectionRejected = rejected
  }

  @action
  handleConnectionRejected() {
    this.errorCallback?.()
  }

  @action
  setErrorCallback(cb: (() => void) | undefined) {
    this.errorCallback = cb
  }
}

export const walletConnectionStore = new WalletConnectionStore()
